<!-- REMOVE when flow component is finished -->

<template>
  <div class="settings-css manage flex column">




    <!-- ADD forbidden block -->




    <ChannelHeader
      image="assets/img/SB-Icons/AI-stars.svg"
      background-color="transparent"
      title="Flow test" />

    <Spinner
      v-if="!flowLoaded"
      class="mt-5"
      :thickness="2" />

    <div v-else>
      <h3>Automations</h3>
      <router-link
        :to="{ name: 'ManageFlow', params: { flowId: 1 } }"
        class="flow-item show-hand"
        tag="div" >
        <div
          class="flex center-all"
          @click="() => {}" >
          <span
            :ref="`response-title-${1}`"
            class="response-keyword greedy ellipsis mr-2 flex flex-align-center" >
            Prvi flow
            <SBIcon
              :id="`${1}-description`"
              class="ml-1"
              :icon="SBIconList.INFORMATION"
              :color="SBColors.greyPrimary"
              :size="12" />
            <b-popover
              :target="`${1}-description`"
              triggers="hover"
              placement="bottom"
              :delay="{ show: 200, hide: 0 } " >
              bla info
            </b-popover>
          </span>
          <div :id="`switch-${1}`">
            <SwitchCheckbox
              v-model="instantReply"
              size="mini-small"
              class="no-label-margin"
              :off-outline-color="SBColors.blackUltralight"
              :value="true"
              @click.native.stop
              @input="() => {}" />
          </div>
          <b-popover
            :target="`switch-${1}`"
            triggers="hover"
            placement="bottom"
            custom-class="basic-popover"
            :delay="{ show: 200, hide: 0 } " >
            Automated response is turned {{ instantReply ? 'ON' : 'OFF' }}
          </b-popover>
        </div>
      </router-link>

      <div
        class="flow-item" >
        <div
          class="flex center-all"
          @click="() => {}" >
          <span
            :ref="`response-title-${1}`"
            class="response-keyword greedy ellipsis mr-2 flex flex-align-center" >
            drugi flow
            <SBIcon
              :id="`${1}-description`"
              class="ml-1"
              :icon="SBIconList.INFORMATION"
              :color="SBColors.greyPrimary"
              :size="12" />
            <b-popover
              :target="`${1}-description`"
              triggers="hover"
              placement="bottom"
              :delay="{ show: 200, hide: 0 } " >
              bla info
            </b-popover>
          </span>
          <div :id="`switch-${1}`">
            <SwitchCheckbox
              v-model="instantReply"
              size="mini-small"
              class="no-label-margin"
              :off-outline-color="SBColors.blackUltralight"
              :value="true"
              @click.native.stop
              @input="() => {}" />
          </div>
          <b-popover
            :target="`switch-${1}`"
            triggers="hover"
            placement="bottom"
            custom-class="basic-popover"
            :delay="{ show: 200, hide: 0 } " >
            Automated response is turned {{ instantReply ? 'ON' : 'OFF' }}
          </b-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner';
import NoPermissionMixin from '@/mixins/AccessPermission';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import CommonActions from '@/components/manage/CommonActions.mixin';
import { treeForm } from '@/components/manage/flowTestStructure';
import SwitchCheckbox from '@/components/common/SwitchCheckbox';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import FlowTree from './FlowTree';
import ChannelHeader from './ChannelHeader';

export default {
  name: 'FlowTest',
  components: {
    ChannelHeader,
    FlowTree,
    Spinner,
    SwitchCheckbox,
    SBIcon,
  },
  mixins: [
    NoPermissionMixin,
    UserPermissionsMixin,
    CommonActions,
  ],
  data() {
    return {
      flowLoaded: true,
      flowData: {},
      SBColors,
      SBIconList,







      instantReply: true,
    };
  },
  mounted() {
    this.flowData = { ...treeForm };
  },
};
</script>

<style lang="scss" scoped>
// #flow-wrapper {
//   width: 100%;
//   height: 100%;
//   // border: 1px solid red;
//   overflow: hidden;
//   position: relative;
//   margin-bottom: 20px;

//   #flow-container {
//     position: absolute;
//     z-index: 9;
//     // text-align: center;
//     // text-wrap: nowrap;
//     white-space: nowrap;
//     transform: scale(var(--zoomLevel));

//     .item {
//       width: 353px;
//       min-height: 63px;
//       padding: 12px 12px 11px 12px;
//       border-radius: 18px;
//       box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
//       border: solid 1px $greyBorder;
//       background-color: $white;

//       .logo-wrapper {
//         width: 40px;
//         height: 40px;
//         padding: 10px;
//         margin-right: 7px;
//         border-radius: 12px;
//         box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.16);
//         border: solid 1px $greyBorder;

//         .image-wrapper {
//           width: 100%;
//           height: 100%;
//           background-image: var(--background-image);
//           background-size: contain;
//           background-repeat: no-repeat;
//           background-position: center;
//         }
//       }

//       h3 {
//         font-size: 12px;
//         font-weight: 400;
//         color: #54626c;
//       }

//       p {
//         font-size: 14px;
//         font-weight: 500;
//         color: $blackPrimary;
//       }
//     }
//   }
// }

h3 {
  margin-top: 35px;
  font-size: 14px;
  font-weight: 400;
  color: $blackUltralight;
}

.flow-item {
  margin: 12px 0;
  position: relative;
  padding: 10px 10px 10px 15px;
  border-radius: 6px;
  box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.1);
  border: solid 1px $greyBorder;
  background-color: $white;
}
</style>
